export const GET_DATE_SLOTS = 'GET_DATE_SLOTS'

export const GET_TIME_SLOTS = 'GET_TIME_SLOTS'

export const GET_TOTAL_AMOUNT = 'GET_TOTAL_AMOUNT'

export const CLEAR_TIME_SLOTS = 'CLEAR_TIME_SLOTS'